// extracted by mini-css-extract-plugin
module.exports = {"root":"feature-grid_root__2JBli","outer":"feature-grid_outer__17GxF","inner":"feature-grid_inner__26jgP"};